import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LoginPage } from "./components/LoginPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RefundAndCancellation from "./components/RefundAndCancellation";
import TermsAndConditions from "./components/TermsAndConditions";
import { AuthenticatedApp } from "./App"; // Import the new wrapper from App.js (adjust path if needed)

// Wrapper to render AuthenticatedApp only on the root path
const AuthenticatedWrapper = ({ user, handleLogout, onLogin }) => {
  const location = useLocation();
  if (location.pathname === '/') {
    return <AuthenticatedApp user={user} handleLogout={handleLogout} />;
  }
  return <Navigate to="/" />;
};

export const AppRoutes = ({ user, handleLogout, onLogin }) => {
  return (
    <Routes>
      {/* Login route - only if not authenticated */}
      <Route
        path="/login"
        element={!user ? <LoginPage onLogin={onLogin} /> : <Navigate to="/" />}
      />

      {/* Authenticated root route - renders tabbed dashboard */}
      <Route
        path="/"
        element={
          user ? (
            <AuthenticatedWrapper user={user} handleLogout={handleLogout} />
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      {/* Settings as a sub-route under authenticated (or keep as tab; this is optional) */}
      <Route
        path="/settings"
        element={user ? <AuthenticatedApp user={user} handleLogout={handleLogout} /> : <Navigate to="/login" />}
      />

      {/* Public routes - accessible without authentication */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/refund" element={<RefundAndCancellation />} />

      {/* Catch-all: redirect to home or login based on auth */}
      <Route
        path="*"
        element={user ? <Navigate to="/" /> : <Navigate to="/login" />}
      />
    </Routes>
  );
};